// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Sv","hidden":"e_Tv","showMore":"e_Uv","features":"e_Vv","featuresOpened":"e_Wv","colorPositive":"e_Xv","colorNegative":"e_Yv","buttonOpen":"e_Zv","hiddenDesktop":"e__v"};